export const dataThumbUp = [
  {
    src: 'delivered_with_care',
    title: 'Delivered with care',
    imputID: 'delivered_with_care',
    imputName: 'icon-thumb-up',
    value: 'Delivered with care',
  },
  {
    src: 'above_and_beyond',
    title: 'Above and beyond',
    imputID: 'above_and_beyond',
    imputName: 'icon-thumb-up',
    value: 'Above and beyond',
  },
  {
    src: 'on_time_delivery',
    title: 'On time delivery',
    imputID: 'on_time_delivery',
    imputName: 'icon-thumb-up',
    value: 'On time delivery',
  },
  {
    src: 'followed_instructions',
    title: 'Followed instructions',
    imputID: 'followed_instructions',
    imputName: 'icon-thumb-up',
    value: 'Followed instructions',
  },
  {
    src: 'respectful_of_property',
    title: 'Respectful of property',
    imputID: 'respectful_of_property',
    imputName: 'icon-thumb-up',
    value: 'Respectful of property',
  },
];

export const dataThumbDown = [
  {
    src: 'package_not_received',
    title: 'Package not received',
    imputID: 'package_not_received',
    imputName: 'icon-thumb-down',
    value: 'Package not received',
  },
  {
    src: 'delivery_late',
    title: 'Delivery late',
    imputID: 'delivery_late',
    imputName: 'icon-thumb-down',
    value: 'Delivery late',
  },
  {
    src: 'instructions_not_followed',
    title: 'Instructions not followed',
    imputID: 'instructions_not_followed',
    imputName: 'icon-thumb-down',
    value: 'Instructions not followed',
  },
  {
    src: 'delivered_to_wrong_address',
    title: 'Delivered to wrong address',
    imputID: 'delivered_to_wrong_address',
    imputName: 'icon-thumb-down',
    value: 'Delivered to wrong address',
  },
  {
    src: 'delivered_not_at_the_front_door',
    title: 'Delivered not at the front door',
    imputID: 'delivered_not_at_the_front_door',
    imputName: 'icon-thumb-down',
    value: 'Delivered not at the front door',
  },
  {
    src: 'package_damaged',
    title: 'Package damaged',
    imputID: 'package_damaged',
    imputName: 'icon-thumb-down',
    value: 'Package damaged',
  },
  {
    src: 'package_content_damaged',
    title: 'Package content damaged',
    imputID: 'package_content_damaged',
    imputName: 'icon-thumb-down',
    value: 'Package content damaged',
  },
  {
    src: 'package_content_incorrect',
    title: 'Package content incorrect',
    imputID: 'package_content_incorrect',
    imputName: 'icon-thumb-down',
    value: 'Package content incorrect',
  },
  {
    src: 'driver_professionalism',
    title: 'Driver professionalism',
    imputID: 'driver_professionalism',
    imputName: 'icon-thumb-down',
    value: 'Driver professionalism',
  },
];
